import alle_release from '../../data/alle_release';

const state = {
    alle_release: []
};

const mutations = {
    'SET_ALLE_RELEASE'(state, alle_release) {
        state.alle_release = alle_release;
    }
};

const actions = {
    init_release: ({commit}) => {
        commit('SET_ALLE_RELEASE', alle_release)
    }
};
const getters = {
    Alle_release: state => {
        return state.alle_release;
    }
};

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/Alle_release.js